module.exports = __webpack_public_path__ + "img/ch26.6facfc45.jpg";